import actionCreatorFactory from 'typescript-fsa';
import { KansatsuKiroku } from '../../../models/KansatsuKiroku';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('kansatsuKiroku');

const fetchRecords = actionCreator.async<
  {
    koujiBangou: string
  }, // started: parameter type
  {
    Items: KansatsuKiroku[];
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('FETCH_RECORDS');

const getRecord = actionCreator.async<
  {
    koujiBangou: string;
    key: string;
  }, // started: parameter type
  {
    Item: KansatsuKiroku;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('GET_RECORD');

const postRecord = actionCreator.async<
  {
    item: KansatsuKiroku;
  }, // started: parameter type
  {
    item: KansatsuKiroku;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('POST_RECORD');

const resetRecord = actionCreator('RESET_RECORD');


export {
  fetchRecords,
  getRecord,
  postRecord,
  resetRecord
};



// WEBPACK FOOTER //
// ./src/redux/modules/kansatsuKiroku/actions.ts